import { Suspense, lazy } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import CreateNewPassword from '../Components/CreateNewPassword';
import Login from '../Components/Login';
import PublicViewContainer from '../Components/PublicView';
import { isPublicView } from '../settings';

export function GlobalRouter() {
  const NotFound = lazy(() => import('./NotFound'));

  return (
    <Switch>
      {isPublicView && <Route path={''} component={PublicViewContainer} />}
      {!isPublicView && (
        <Route path={'/ResetPassword'} component={CreateNewPassword} />
      )}
      {!isPublicView && <Route path={'/Login'} component={Login} />}
      {!isPublicView ? <Redirect to="/Login" /> : <Redirect to="/" />}
      <Suspense fallback={<></>}>
        <NotFound />
      </Suspense>
    </Switch>
  );
}

export default GlobalRouter;
